"use client";

import { IconCancel } from "@tabler/icons-react";
import { useLanguage } from "../../../context/LanguageContext";

type Props = {};

const SectionHeader = ({ icon: Icon, title }: { icon: any; title: string }) => (
  <div className="flex items-center gap-2 border-b border-[#FBD037]/30 pb-2 mb-3">
    <div className="p-1.5 rounded-lg bg-[#FBD037]/20">
      <Icon size={16} className="text-[#212121]" stroke={1.5} />
    </div>
    <p className="text-[#212121]/80 uppercase text-[11px] font-bold tracking-wide">
      {title}
    </p>
  </div>
);

const CancelModal = (props: Props) => {
  const { t } = useLanguage();

  return (
    <div className="group  rounded-2xl bg-gradient-to-b from-white/90 to-white/60 backdrop-blur-xl border border-[#D2D2D2]/70 p-4 transition-all duration-300 space-y-3">
      <div className="absolute inset-0 rounded-3xl bg-gradient-to-tr from-yellow-200/20 to-transparent pointer-events-none" />
      <SectionHeader icon={IconCancel} title={t("confirm")} />
      <div className="">
        <h2 className="text-[#212121] font-medium text-base">
          {t("are you sure you want to cancel request?")}
        </h2>
      </div>
    </div>
  );
};

export default CancelModal;
